// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"5c705b71","229":"7bf9312a","328":"df0a4caf","380":"54d12ce6","449":"2e4ac257","859":"82eff2f9","948":"a526f43b"}[chunkId] + ".chunk.js";
};